import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { HelpVideo } from 'apps/wsg/src/app/admin/help-video/help-video';
import { CONNECTED_DIALOG_DATA } from '@morningstar/shared/ui-kit/connected-dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'wsg-help-video-icon-dialog',
  templateUrl: './help-video-icon-dialog.component.html',
  styleUrls: ['./help-video-icon-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpVideoIconDialogComponent {

  constructor(@Inject(CONNECTED_DIALOG_DATA) public video: HelpVideo, private sanitizer: DomSanitizer) { }

  getSanitizedUrl(url: string) {

    if(url.indexOf('youtu.be') !== -1) {
      const [first, second] = url.split('.be/');

      url = `${first}be.com/embed/${second}`;
    }

    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
